import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  const linkGroups = [
    {
      id: 'footer_facilities',
      title: 'Facilities',
      links: [
        { id: 'footer_request', label: 'Request Candidates', href: '/for-facilities#request-form' },
        { id: 'footer_process', label: 'How It Works', href: '/for-facilities#process' },
        { id: 'footer_guarantee', label: 'Our Guarantee', href: '/for-facilities#guarantee' },
      ],
    },
    {
      id: 'footer_clinicians',
      title: 'Clinicians',
      links: [
        { id: 'footer_apply', label: 'Apply Now', href: '/for-clinicians#apply-form' },
        { id: 'footer_jobs', label: 'Browse Jobs', href: '/jobs' },
        { id: 'footer_support', label: 'Career Support', href: '/for-clinicians#support' },
      ],
    },
    {
      id: 'footer_company',
      title: 'Company',
      links: [
        { id: 'footer_about', label: 'About', href: '/about' },
        { id: 'footer_contact', label: 'Contact', href: '/contact' },
        { id: 'footer_faq', label: 'FAQs', href: '/homepage#faq' },
      ],
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-white to-accent border-t border-border">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Top Row - Link Groups */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {linkGroups?.map((group) => (
            <div key={group?.id}>
              <h3 className="text-sm sm:text-base font-semibold text-primary mb-4 uppercase tracking-wider">
                {group?.title}
              </h3>
              <ul className="space-y-3">
                {group?.links?.map((link) => (
                  <li key={link?.id}>
                    <Link
                      href={link?.href}
                      className="text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors inline-flex items-center group"
                    >
                      <span className="group-hover:translate-x-1 transition-transform duration-300">{link?.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Row - Legal & Social */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-border">
          <p className="text-sm sm:text-base text-muted-foreground mb-4 md:mb-0">
            © {currentYear} INF Medical. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <Link
              href="/privacy"
              className="text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors"
            >
              Privacy
            </Link>
            <span className="text-muted-foreground">·</span>
            <Link
              href="/terms"
              className="text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors"
            >
              Terms
            </Link>
            <span className="text-muted-foreground">·</span>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label="LinkedIn"
            >
              <Icon name="LinkIcon" size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}